<div class="noaccess">
  <div class="noaccess-card">
    <div class="noaccess-art" aria-hidden="true">
      <span class="noaccess-ring"></span>
      <mat-icon>verified_user</mat-icon>
    </div>

    <h1>You're all set up &mdash; almost!</h1>
    <p class="noaccess-lead">
      Your account is active, but no application modules have been assigned to your role yet.
      Once access is granted, everything you need will appear in the menu on your next login.
    </p>

    <div class="noaccess-details">
      <div class="noaccess-detail" *ngIf="email">
        <mat-icon aria-hidden="true">person</mat-icon>
        <span><span class="noaccess-label">Signed in as</span>{{email}}</span>
      </div>
      <div class="noaccess-detail" *ngIf="officeName">
        <mat-icon aria-hidden="true">business</mat-icon>
        <span><span class="noaccess-label">Office</span>{{officeName}}</span>
      </div>
    </div>

    <div class="noaccess-help">
      <h2>What you can do</h2>
      <ul>
        <li>
          <mat-icon aria-hidden="true">admin_panel_settings</mat-icon>
          <span>Ask your <strong>organization administrator</strong> to assign modules to your role.</span>
        </li>
        <li>
          <mat-icon aria-hidden="true">support_agent</mat-icon>
          <span>Or contact <strong>Flowtrics support</strong> and we'll be glad to help.</span>
        </li>
        <li>
          <mat-icon aria-hidden="true">swap_horiz</mat-icon>
          <span>If you work in more than one office, try switching office from the top bar.</span>
        </li>
      </ul>
    </div>

    <div class="noaccess-actions">
      <button mat-flat-button color="primary" type="button" (click)="signOut()">
        <mat-icon>logout</mat-icon> Sign out
      </button>
    </div>
  </div>
</div>
